import React, { useState, useEffect } from 'react';
import PropertySubscriptionFlow from '../components/PropertySubscriptionFlow';

const SubscriptionPage = () => {
  const [properties, setProperties] = useState([]);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Fetch properties
        const propertiesResponse = await fetch('/api/properties', {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        });
        
        if (propertiesResponse.ok) {
          const propertiesData = await propertiesResponse.json();
          console.log('Fetched properties:', propertiesData);
          console.log('Properties data type:', typeof propertiesData);
          
          // Handle different response formats
          let parsedProperties = [];
          if (Array.isArray(propertiesData)) {
            parsedProperties = propertiesData;
          } else if (propertiesData.properties && Array.isArray(propertiesData.properties)) {
            parsedProperties = propertiesData.properties;
          } else if (propertiesData.data && Array.isArray(propertiesData.data)) {
            parsedProperties = propertiesData.data;
          } else {
            console.warn('Unexpected properties data format:', propertiesData);
          }
          
          console.log('Parsed properties:', parsedProperties);
          setProperties(parsedProperties);
        } else {
          console.error('Failed to fetch properties:', propertiesResponse.status);
          const errorText = await propertiesResponse.text();
          console.error('Error response:', errorText);
        }

        // Fetch subscription plans
        const plansResponse = await fetch('/api/subscriptions/tiers', {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        });
        
        if (plansResponse.ok) {
          const plansData = await plansResponse.json();
          console.log('Fetched plans:', plansData);
          console.log('Plans data type:', typeof plansData);
          
          // Handle different response formats
          let parsedPlans = [];
          if (Array.isArray(plansData)) {
            parsedPlans = plansData;
          } else if (plansData.data && Array.isArray(plansData.data)) {
            parsedPlans = plansData.data;
          } else if (plansData.plans && Array.isArray(plansData.plans)) {
            parsedPlans = plansData.plans;
          } else {
            console.warn('Unexpected plans data format:', plansData);
          }
          
          console.log('Parsed plans:', parsedPlans);
          setPlans(parsedPlans);
        } else {
          console.error('Failed to fetch plans:', plansResponse.status);
          const errorText = await plansResponse.text();
          console.error('Plans error response:', errorText);
        }
        
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <PropertySubscriptionFlow 
      properties={properties}
      plans={plans}
      loading={loading}
    />
  );
};

export default SubscriptionPage;